export default defineNuxtRouteMiddleware((to) => {
  if (to.meta?.tag && to.meta.tag === 'dev') {
    toast.warning('正在开发中，敬请期待！', {
      position: 'top-center',
      closeButton: false,
    });
    return abortNavigation();
  }
});
